import React, { useState } from "react";
import { FormikProps } from "formik";
import { Person } from "../../../../model/Person";
import { Box, Button, ButtonGroup } from "@material-ui/core";
import { ApiBackend } from "../../../../providers/apibackend";
import PersonPrintDialog from "./PersonPrintDialog";

interface IProps extends FormikProps<Person> {
}

const EditPersonActions = (props: IProps) => {
    const [showPrintDialog, setShowPrintDialog] = useState(false);

    const api = new ApiBackend();

    const handleLogin = async (method: string) => {
        const { values } = props;
        const token = await api.createTransferTokenForPerson(values.id, method);
        window.open(`${CONFIG.minaSidorUrl}?token=${token.id}&profile=${values.id}&isadmin=true`);
    };

    const render = () => {
        const { values, dirty } = props;

        return (<>
            <Box className="MuiFormControl-root">
                <ButtonGroup disabled={dirty} color="secondary" >
                    <Button
                        disabled={!values.email}
                        onClick={() => {
                            handleLogin("email");
                        }}>
                        Logga in med epost
                    </Button>
                    <Button
                        disabled={!values.mobileNumber}
                        onClick={() => {
                            handleLogin("phone");
                        }}>
                        Logga in med mobil
                    </Button>
                </ButtonGroup>
            </Box>
            <Box>
                <ButtonGroup disabled={dirty} color="secondary">
                    <Button
                        onClick={() => {
                            setShowPrintDialog(true);
                        }}>
                        Skriv ut
                    </Button>
                </ButtonGroup>
            </Box>

            {showPrintDialog &&
                <PersonPrintDialog {...props}
                    onClose={() => {
                        setShowPrintDialog(false);
                    }}
                />
            }
        </>);
    };

    return render();
};

export default EditPersonActions;
